var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { Box, Typography, RefreshIcon, Button } from '@kareo/design-system';
import CardActionArea from '@material-ui/core/CardActionArea';
import { CardTypes, } from 'shared-assets/facesheet-ui/service/facesheet/types';
import Loader from 'shared-assets/components/Loader';
import rollbar from 'shared-assets/src/errors/errors';
import CardContentContainer from 'shared-assets/facesheet-ui/components/Facesheet/Card/CardContentContainer';
import { FacesheetStyledCard, FacesheetCardTitle, FacesheetCardContent, } from 'shared-assets/facesheet-ui/utils/styledFacesheet';
import CardContentError from 'shared-assets/facesheet-ui/components/Facesheet/Error/CardContentError';
import { ErrorBoundary } from 'react-error-boundary';
import { CACHED_DATA_STATUS_CODE, DATE_CACHED_HTTP_HEADER, } from '../../../service/facesheet/types';
var FacesheetCard = function (_a) {
    var patientId = _a.patientId, title = _a.title, url = _a.url, fetchCardData = _a.fetchCardData, patientStatus = _a.patientStatus;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), cardData = _c[0], setCardData = _c[1];
    var _d = useState(false), inError = _d[0], setInError = _d[1];
    var _e = useState(false), isEmpty = _e[0], setIsEmpty = _e[1];
    var _f = useState(''), cachedDate = _f[0], setCachedDate = _f[1];
    useEffect(function () {
        if (patientId && patientId > 0) {
            loadCardData();
        }
    }, [patientId]);
    var loadCardData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var cardResponse, contentType, body, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, 7, 8]);
                    return [4 /*yield*/, fetchCardData(patientId)];
                case 1:
                    cardResponse = _a.sent();
                    if (!(cardResponse === null || cardResponse === void 0 ? void 0 : cardResponse.ok)) return [3 /*break*/, 4];
                    if ((cardResponse === null || cardResponse === void 0 ? void 0 : cardResponse.status) === CACHED_DATA_STATUS_CODE) {
                        setCachedDate(cardResponse.headers.get(DATE_CACHED_HTTP_HEADER));
                    }
                    else {
                        setCachedDate('');
                    }
                    contentType = cardResponse.headers.get('content-type');
                    if (!(contentType && contentType.startsWith('application/json'))) return [3 /*break*/, 3];
                    return [4 /*yield*/, cardResponse.json()];
                case 2:
                    body = _a.sent();
                    setCardData(body);
                    setIsEmpty(body.length <= 0);
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    setInError(true);
                    _a.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6:
                    error_1 = _a.sent();
                    setInError(true);
                    rollbar.error(error_1);
                    return [3 /*break*/, 8];
                case 7:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var refreshCardData = function (event) {
        event.stopPropagation();
        setCachedDate('');
        setIsEmpty(false);
        setInError(false);
        setLoading(true);
        loadCardData();
    };
    var displayErrorOrNoData = function (isEmpty, inError) {
        if (inError) {
            return React.createElement(CardContentError, { refreshCardData: refreshCardData });
        }
        else if (isEmpty) {
            return (React.createElement(Typography, { variant: "body1", component: "div" }, "(None documented)"));
        }
    };
    var errorFallback = function () {
        return React.createElement(CardContentError, { refreshCardData: refreshCardData });
    };
    var handleRefreshClick = function (event) {
        event.stopPropagation();
        setLoading(true);
        loadCardData();
    };
    var handleCardActionAreaClick = function (event) {
        if (loading) {
            event.preventDefault();
        }
        else {
            window.location.href = url;
        }
    };
    var card = (React.createElement(FacesheetStyledCard, null,
        React.createElement(Box, null,
            React.createElement(FacesheetCardTitle, { title: React.createElement(Typography, { variant: "h2", color: "primary", component: "div" }, title), action: !inError &&
                    cachedDate && (React.createElement(Button, { variant: "text", startIcon: React.createElement(RefreshIcon, { color: "primary", fontSize: "small" }), onClick: handleRefreshClick }, "Refresh")) })),
        React.createElement(Loader, { condition: !loading },
            React.createElement(FacesheetCardContent, null, isEmpty || inError ? (displayErrorOrNoData(isEmpty, inError)) : (React.createElement(ErrorBoundary, { FallbackComponent: errorFallback, onError: function (error) {
                    rollbar.error(error);
                } },
                React.createElement(CardContentContainer, { type: title, data: cardData, patientId: patientId, patientStatus: patientStatus, cachedDate: cachedDate })))))));
    return (React.createElement(React.Fragment, null, title === CardTypes.Recommendations ? (React.createElement(Box, { position: "relative" }, card)) : (React.createElement(CardActionArea, { onClick: handleCardActionAreaClick }, card))));
};
export default FacesheetCard;
